module.exports = __webpack_public_path__ + "static/media/miro.f8f44db9.svg";